import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_QCX_API_BASE_URL! + '/followup/report/processos-exportacao';

export interface ProcessosExportacaoFiltros {
  tenantIds: string[];
  clientIds: string[];
  dataRegistroDueRange: string;
  dataDesembaracoRange: string;
  dataAverbacaoRange: string;
}

export const generateProcessosExportacaoReport = async (
  token: string,
  unidadeId: string,
  filtros: ProcessosExportacaoFiltros
): Promise<string | null> => {
  const params = new URLSearchParams();
  params.set('tenantId', filtros.tenantIds.join(','));

  if (filtros.clientIds.length > 0) {
    params.set('clientesId', filtros.clientIds.join(','));
  }
  if (filtros.dataRegistroDueRange) {
    params.set('dataRegistroDueRange', filtros.dataRegistroDueRange);
  }
  if (filtros.dataDesembaracoRange) {
    params.set('dataDesembaracoRange', filtros.dataDesembaracoRange);
  }
  if (filtros.dataAverbacaoRange) {
    params.set('dataAverbacaoRange', filtros.dataAverbacaoRange);
  }

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
      // faz com que o Axios NÃO jogue para o catch em status ≥400
      validateStatus: () => true,
    });

    // sucesso
    if (response.status === 200) {
      const dataAtual = new Date().toISOString().slice(0, 10);
      const file = new File([response.data], `PROCESSOS DE EXPORTAÇÃO - ${dataAtual}.xlsx`, {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
      return null;
    }

    // erro do servidor: extrai o texto da blob
    const errText = await response.data.text();
    return errText || 'Erro ao gerar o relatório.';
  } catch (networkError) {
    // caso de falha de rede / timeout etc
    return 'Não foi possível conectar ao servidor para gerar o relatório.';
  }
};
